/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isresponsible1Inputs */

const en_entity_isresponsible1 = /** @type {(inputs: Entity_Isresponsible1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Responsible`)
};

const de_entity_isresponsible1 = /** @type {(inputs: Entity_Isresponsible1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist verantwortlich`)
};

/**
* | output |
* | --- |
* | "Is Responsible" |
*
* @param {Entity_Isresponsible1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isresponsible1 = /** @type {((inputs?: Entity_Isresponsible1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isresponsible1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isresponsible1(inputs)
	return de_entity_isresponsible1(inputs)
});
export { entity_isresponsible1 as "entity_isResponsible" }